import React from "react";
import { BiLogoDiscordAlt, BiLogoInstagram } from "react-icons/bi";
import { BsGithub, BsReddit } from "react-icons/bs";

const Community = () => {
  const socialLinks = [
    {
      name: "Discord",
      description: "انضم لسيرفر للبحث عن فريق",
      Icon: BiLogoDiscordAlt,
      link: "https://discord.gg/jpRGNsyfcw",
    },
    {
      name: "Instagram",
      description: "تابعنا على Instagram",
      Icon: BiLogoInstagram,
      link: "https://instagram.com/qimma.dev",
    },
    {
      name: "GitHub",
      description: "تابع المشاريع والأدوات المفتوحة المصدر",
      Icon: BsGithub,
      link: "https://github.com/Q1mma",
    }
  ];

  const organizers = [
    {
      name: "r/EgyptianFreelancers",
      description: "المجتمع المنظم للهاكاثون",
      Icon: BsReddit,
      link: "https://www.reddit.com/r/EgyptianFreelancers/",
    },
    {
      name: "r/Egypt_Developers",
      description: "المجتمع المنظم للهاكاثون",
      Icon: BsReddit,
      link: "https://www.reddit.com/r/Egypt_Developers/",
    }
  ];

  return (
    <section className="relative py-20 md:py-32 bg-blue overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4 uppercase tracking-wide">
              انضم للمجتمع
            </h2>
            <div className="w-24 h-1 bg-yellow mx-auto rounded-full mb-4"></div>
            <p className="text-lg text-white/90 leading-relaxed max-w-2xl mx-auto">
              انضم إلى Discord للتواصل مع المطورين وتكوين فريقك إذا لم يكن لديك واحد
            </p>
          </div>

          {/* Social Links */}
          <div className="mb-10">
            <div className="grid md:grid-cols-3 gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative bg-dark-blue rounded-2xl p-6 border border-white/10 hover:border-yellow transition-all  hover:scale-105 block"
                >
                  <div className="flex flex-col items-center text-center gap-3">
                    <div className="w-16 h-16 rounded-xl bg-yellow/20 flex items-center justify-center group-hover:scale-110 transition-transform ">
                      <social.Icon className="text-4xl text-yellow" />
                    </div>
                    
                    <div>
                      <h3 className="text-lg font-semibold text-white mb-1">
                        {social.name}
                      </h3>
                      <p className="text-sm text-white/70">
                        {social.description}
                      </p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Organizers Section */}
          <div>
            <h3 className="text-xl md:text-2xl font-semibold text-white mb-4 text-center">
              المجتمعات المنظمة
            </h3>
            <div className="grid md:grid-cols-2 gap-4">
              {organizers.map((organizer, index) => (
                <a
                  key={index}
                  href={organizer.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative bg-dark-blue rounded-2xl p-6 border border-white/10 hover:border-yellow transition-all  hover:scale-105"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-14 h-14 rounded-xl bg-yellow/20 flex items-center justify-center group-hover:scale-110 transition-transform ">
                      <BsReddit className="text-3xl text-yellow" />
                    </div>
                    
                    <div className="flex-1 text-right">
                      <h4 className="text-lg font-semibold text-white mb-1">
                        {organizer.name}
                      </h4>
                      <p className="text-white/70 text-xs">
                        {organizer.description}
                      </p>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Community;

